import React from 'react';

import logo from './mgm-resorts.svg';

export const Logo = ({
  // eslint-disable-next-line react/prop-types
  width = 180,
  // eslint-disable-next-line react/prop-types
  height,
  ...imgProps
}: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) => (
  <img src={logo} width={width} height={height} alt='MGM Resorts' {...imgProps} />
);
